export enum CacheKeys {
  Ease = 'ease',
  EmailApiSubscription = 'emailApiSubscription',
  MarketingCampaignSubscription = 'marketingCampaignSubscription',
}
